import React from "react";
import { FaPrint } from "react-icons/fa";

export default function Print(props) {

  return (
    <>
      <div className="icon-button">
        <FaPrint/>
      </div>
    </>
  );
}
